import { render, staticRenderFns } from "./answerScriptDistributionList.vue?vue&type=template&id=d9110888&"
import script from "./answerScriptDistributionList.vue?vue&type=script&lang=js&"
export * from "./answerScriptDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports